export default __webpack_public_path__ + "static/media/spirituality.b17aedc3.jpg";